import React from 'react';
import { FormField } from './FormField';
import { usePropertyFormContext } from '../contexts/PropertyFormContext';

interface PropertyType {
  id: string;
  name: string;
}

const getAllPropertyTypes = (): PropertyType[] => [
  { id: '1', name: 'Appartement' },
  { id: '2', name: 'Maison' },
  { id: '4', name: 'Terrain' },
  { id: '5', name: 'Commerce' },
];

const getRentalPropertyTypes = (): PropertyType[] => [
  { id: '1', name: 'Appartement' },
  { id: '2', name: 'Maison' },
  { id: '4', name: 'Terrain' },
  { id: '5', name: 'Commerce' },
];

export const PropertyTypeSelector: React.FC = () => {
  const { formData, handleInputChange } = usePropertyFormContext();

  // Get appropriate property types based on transaction type
  const propertyTypes = formData.transactionType === 'sale' 
    ? getAllPropertyTypes()
    : getRentalPropertyTypes();

  const handleTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    handleInputChange({
      target: {
        name: 'propertyType',
        value: e.target.value,
        type: 'select'
      }
    } as React.ChangeEvent<HTMLSelectElement>);
  };

  return (
    <FormField label="Type de bien">
      <select
        name="propertyType"
        value={formData.propertyType}
        onChange={handleTypeChange}
        className="w-full"
      >
        <option value="">Sélectionner</option>
        {propertyTypes.map(type => (
          <option key={type.id} value={type.name}>
            {type.name}
          </option>
        ))}
      </select>
    </FormField>
  );
};